//#region src/variants/variants_keyboard_shortcut.js
var variants_keyboard_shortcut_default = {
	default: { props: { shortcut: { initialValue: "{cmd}+Ctrl+X" } } },
	"available shortcut aliases": { props: { shortcut: { initialValue: "{cmd}+{opt}+{win}+{arrow-right}+{arrow-left}+{arrow-up}+{arrow-down}+A" } } }
};
//#endregion
export { variants_keyboard_shortcut_default as default };

//# sourceMappingURL=variants_keyboard_shortcut.js.map